export const Linkedin = (props) => {
  const { size = 16, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M4.98292 7.19631C6.19132 7.19631 7.17092 6.21671 7.17092 5.00831C7.17092 3.79991 6.19132 2.82031 4.98292 2.82031C3.77452 2.82031 2.79492 3.79991 2.79492 5.00831C2.79492 6.21671 3.77452 7.19631 4.98292 7.19631Z'
          fill='currentColor'
        />
        <path
          d='M9.23673 8.85469V20.9937H13.0057V14.9907C13.0057 13.4067 13.3037 11.8727 15.2677 11.8727C17.2047 11.8727 17.2287 13.6837 17.2287 15.0907V20.9947H20.9997V14.3377C20.9997 11.0677 20.2957 8.55469 16.4737 8.55469C14.6387 8.55469 13.4087 9.56169 12.9057 10.5147H12.8547V8.85469H9.23673ZM3.09473 8.85469H6.86973V20.9937H3.09473V8.85469Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};
